<template>
  <canvas class="curved-text-canvas" width="500" height="300" ref="canvas" />
</template>


<script>

export default {
  name: 'CurvedTextCanvas',

  props: {
    text: {
      type: String,
      required: true
    },
    radius: {
      type: Number,
      required: true
    }
  },

  mounted () {
    this._context = this.$refs.canvas.getContext('2d')
    this._context.font = '600 14px Muli'
    this._context.textAlign = 'center'
    this.updateText()
  },

  watch: {
    text () {
      this.updateText()
    }
  },

  methods: {
    updateText () {
      this._context.clearRect(0, 0, this.$refs.canvas.width, this.$refs.canvas.height)
      this.drawTextAlongArc(this._context, this.text, 250, 300, 20, Math.PI * 0.2)
    },

    drawTextAlongArc (context, str, centerX, centerY, radius, angle) {
      context.save()
      context.translate(centerX, centerY)
      context.rotate(-1 * angle / 2)
      context.rotate(-1 * (angle / str.length) / 2)

      for (var n = 0; n < str.length; n++) {
        context.rotate(angle / str.length)
        context.save()
        context.translate(0, -1 * radius)
        var char = str[n]
        context.fillText(char, 0, 0)
        context.restore()
      }
      context.restore()
    }
  }
}
</script>

<style lang="scss">

// .curved-text-canvas {
//   border: 1px solid;
// }

</style>



// WEBPACK FOOTER //
// src/atoms/CurvedTextCanvas.vue